import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { paymentMethods } from "../../../actions/creators/checkout/payment";
import {
    getIeCardData,
    getIeSignUpPaymentGateway,
    getNewLoopCardPaymentResult,
    getUserInfo,
    isNewLoopCardPaymentProcessing,
} from '../../../reducers';
import PaymentSidebar from '../../checkout/PaymentSidebar';
import IeSignUpSuccessMessage from '../IeSignUpSuccessMessage';
import CardAnimation from '../../checkout/CardAnimation';
import LogoLoading from '../../LogoLoading';
import { CHECKOUT_CONTEXT_NEW_LOOP_CARD } from '../../../actions/creators/checkout';
import { hasIeAction } from '../../../utils/misc';
import RequireAuthMessage from '../RequireAuthMessage';
import { newLoopCardConfirmSubmit, newLoopCardLoaded } from '../../../actions/creators/user';
import { isNewLoopCardConfirmProcessing } from '../../../reducers/user';
import Dialog from '../../Dialog';

interface Props {
    cardData: any;
    isProcessing: boolean;
    paymentGateway: string;
    price: number;
    result: any;
    user: any;
    onCancel: () => void;
    newLoopCardConfirmSubmit: () => void;
    newLoopCardLoaded: () => void;
}

const LoopNewCardPage: React.FC<Props> = (props) => {
    const [data, setData] = React.useState<{ gateway: string, price: number } | null>(null);
    const [dialogOk, setDialogOk] = React.useState<boolean>(false);

    useEffect(() => {
        props.newLoopCardLoaded();
    }, []);

    useEffect(() => {
        if (!props.user) return;

        const userData = props.user['ie-actions'].find(action => action.action === 'new-loop-card');
        if (userData) {
            setData(userData.data);
        }
    }, [props.user]);

    useEffect(() => {
        if (!data || !data.gateway || !dialogOk) return;

        if (0 === data.price) {
            props.newLoopCardConfirmSubmit();
            return;
        }
    }, [data, dialogOk]);

    if (!props.user) {
        return <RequireAuthMessage>
            <p>Por favor, inicia sesión para comenzar.</p>
        </RequireAuthMessage>;
    }

    if (!hasIeAction(props.user, 'new-loop-card') || !data) {
        return <p>Lo sentimos, no tienes acceso a esta sección.</p>;
    }

    return (
        <>
            <Helmet><title>Cambia tu tarjeta Cinemex Loop - Cinemex</title></Helmet>

            {props.isProcessing && props.price && <CardAnimation />}
            {props.isProcessing && !props.price && <LogoLoading />}

            {!dialogOk && <>
                <Dialog dialog={displayAlert({ setDialogOk, onCancel: props.onCancel })} />
                <LogoLoading />
            </>}

            {props.result && <IeSignUpSuccessMessage
                title="Tu cambio de tarjeta ha sido completado 🤩"
                cardData={props.cardData}
            />}

            {!props.result && (
                <div>
                    {dialogOk && data.gateway && data.price > 0 && <PaymentSidebar
                        cash={data.price}
                        ccRequired={true}
                        context={CHECKOUT_CONTEXT_NEW_LOOP_CARD}
                        method={paymentMethods.creditCard}
                        paymentGateway={data.gateway}
                        onCancel={props.onCancel}
                        transactionData={{
                            type: 'new-loop-card',
                            amount: data.price
                        }}
                    />}
                </div>
            )}
        </>
    );
}

function displayAlert({ setDialogOk, onCancel }) {
    return {
        message: '¡Aviso! Al completar este proceso, tu tarjeta anterior ya no será válida y solo podrás utilizar la nueva tarjeta. ¿Deseas continuar?',
        buttons: [
            {
                label: 'Más tarde',
                onClick: () => {
                    onCancel();
                }
            },
            {
                label: 'Continuar',
                primary: true,
                onClick: () => {
                    setDialogOk(true);
                }
            }
        ]
    };
}

const mapStateToProps = state => ({
    cardData: getIeCardData(state),
    isProcessing: isNewLoopCardPaymentProcessing(state) || isNewLoopCardConfirmProcessing(state),
    paymentGateway: getIeSignUpPaymentGateway(state),
    result: getNewLoopCardPaymentResult(state),
    user: getUserInfo(state),
});

const mapDispatchToProps = ({
    newLoopCardConfirmSubmit,
    newLoopCardLoaded,
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(LoopNewCardPage));